export const APP_MODULE = 'mobi-app';
